import React from 'react';
import glamorous, { withTheme } from 'glamorous';
import { css } from 'glamor';
import Link from 'redux-first-router-link';

import { propTypes, defaultProps } from './types';
import * as styles from './styles';

const GlamAnchor = glamorous.a(styles.Button);
const GlamButton = glamorous.button(styles.Button);
const IconContainer = glamorous.div(styles.IconContainer);

export class Button extends React.PureComponent {
  static propTypes = propTypes;
  static defaultProps = defaultProps;

  state = {
    focused: false,
  };

  componentDidMount() {
    this.hasMounted = true;
  }

  componentWillUnmount() {
    this.hasMounted = false;
  }

  get label() {
    return this.props.label || this.props.children;
  }

  setFocused = focused => this.hasMounted ? this.setState({ focused }) : null;

  handleBlur = (e) => {
    this.setFocused(false);
    this.props.onBlur(e);
  };

  handleFocus = (e) => {
    this.setFocused(true);
    this.props.onFocus(e);
  };

  handleMouseDown = (e) => {
    this.setFocused(true);

    setTimeout(() => {
      this.setFocused(false);
    }, 1);
    this.props.onMouseDown(e);
  };

  renderLeftIcon() {
    const props = {
      leftIcon: true,
      iconOffsetLeft: this.props.iconOffsetLeft,
    };

    return (
      <IconContainer {...props}>
        {this.props.leftIcon}
      </IconContainer>
    );
  }

  renderRightIcon() {
    const props = {
      rightIcon: true,
      iconOffsetRight: this.props.iconOffsetRight,
    };

    return (
      <IconContainer {...props}>
        {this.props.rightIcon}
      </IconContainer>
    );
  }

  renderChildren() {
    return (
      <React.Fragment>
        {this.props.leftIcon && this.renderLeftIcon()}
        {this.label}
        {this.props.rightIcon && this.renderRightIcon()}
      </React.Fragment>
    );
  }

  render () {
    const {
      style,
      navTo,
      href,
      ...rest
    } = this.props;

    const buttonHandlers = {
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      onMouseDown: this.handleMouseDown,
    };

    const glamProps = {
      ...rest,
      ...this.state,
      glamStyle: style,
    };

    if (navTo) {
      return (
        <Link
          to={navTo}
          className={css(styles.Button(glamProps))}
          {...buttonHandlers}
        >
          {this.renderChildren()}
        </Link>
      );
    } else if (href) {
      return (
        <GlamAnchor
          href={href}
          {...glamProps}
          {...buttonHandlers}
        >
          {this.renderChildren()}
        </GlamAnchor>
      );
    }

    return (
      <GlamButton
        {...glamProps}
        {...buttonHandlers}
      >
        {this.renderChildren()}
      </GlamButton>
    );
  }
}

export default withTheme(Button);




// WEBPACK FOOTER //
// ./src/components/ui/Button/Button.js